<template>
    <div class="notification-reminder-activity">
        <CompassObject size="small" type="object" :object="object" />
        <div class="notification-reminder-activity__content">
            <p class="typographies-paragraph-medium-regular">
                {{ text.title }}
                <span v-if="!!text.relatedName" class="typographies-paragraph-medium-bold">
                    {{ text.relatedName }}
                </span>
                {{ text.dueDatePrefix }}
                <span class="typographies-paragraph-medium-bold">
                    {{ $filters.lowerCase(text.dateHumanized) }}
                </span>
            </p>
            <span
                v-if="context === NOTIFICATION_CONTEXT.NOTIFICATION_CENTER"
                class="notification-reminder-activity__content-caption typographies-paragraph-small-regular"
            >
                {{ caption }}
            </span>
        </div>
    </div>
</template>

<script>
import { getFullNameUser } from 'Helpers/avatarHelper';
import { NOTIFICATION_CONTEXT } from 'Dictionaries/notification/NotificationEnums';

export default {
    props: {
        notification: {
            type: Object,
            required: true,
        },
        context: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            NOTIFICATION_CONTEXT,
        };
    },
    computed: {
        object() {
            return this.notification.type === 'task' ? 'task' : 'phone';
        },
        text() {
            if (this.notification.type === 'task') {
                const titleKey = !!this.notification.task.related.length
                    ? 'notification.NotificationReminderActivity.task_title_with_related'
                    : 'notification.NotificationReminderActivity.task_title';

                return {
                    title: this.$t.__(titleKey, {
                        taskTitle: this.notification.task.title,
                    }),
                    relatedName: this.getRelatedName(
                        this.notification.task._embed?.related?.at(0),
                        this.notification.task.related?.at(0)?.type,
                    ),
                    dueDatePrefix: this.$t.__(
                        'notification.NotificationReminderActivity.due_date_prefix',
                    ),
                    dateHumanized: this.getDateHumanized(),
                };
            } else {
                return '';
            }
        },
        caption() {
            try {
                return moment(this.notification.created).fromNow();
            } catch {
                return '';
            }
        },
    },
    methods: {
        getDateHumanized() {
            const reminder = this.notification.task.reminders.find(
                (reminder) => reminder.medium === 'inapp',
            );

            let humanizedDueDate = this.$t.__(
                'notification.NotificationReminderActivity.today_reminder',
            );

            if (reminder && ['1day', '1week', '1month'].includes(reminder.delay)) {
                humanizedDueDate = `le ${this.$filters.dateFormatter(
                    this.notification.task.due_date,
                    'NORMAL_DATE',
                    false,
                )}`;
            }

            const time = moment(this.notification.task.due_date).format('HH:mm');
            return `${time}, ${humanizedDueDate}`;
        },
        getRelatedName(related, relatedType) {
            if (!related || !relatedType) {
                return null;
            }

            switch (relatedType) {
                case 'opportunity':
                case 'estimate':
                case 'invoice':
                case 'creditnote':
                case 'order':
                    return related.number;
                case 'company':
                    return related.name;
                default:
                    return getFullNameUser(related);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.notification-reminder-activity {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);

    &__content {
        display: flex;
        flex-direction: column;
        p {
            margin: 0;
            word-break: break-word;
        }
        &-caption {
            color: var(--colors-common-text-subtle-default);
        }
    }
}
</style>
